let searchParams: URLSearchParams | undefined;

if (!searchParams) {
    searchParams = new URL(window.location.href).searchParams;
}
// ?defaultWokaName=name&skipCameraPage=true&provideDefaultWokaName=fix-plus-random-numbers&enableTutorial=false

export const SP_DEFAULT_WOKA_NAME = searchParams.get("defaultWokaName") ?? undefined;

export const SP_ENABLE_TUTORIAL =
    searchParams.get("enableTutorial") === "true"
        ? true
        : searchParams.get("enableTutorial") === "false"
        ? false
        : undefined;

export const SP_PROVIDE_DEFAULT_WOKA_NAME = ["no", "random", "fix", "fix-plus-random-numbers"].includes(
    searchParams.get("provideDefaultWokaName") || ""
)
    ? (searchParams.get("provideDefaultWokaName") as "no" | "random" | "fix" | "fix-plus-random-numbers")
    : undefined;

export const SP_SKIP_CAMERA_PAGE =
    searchParams.get("skipCameraPage") === "true"
        ? true
        : searchParams.get("skipCameraPage") === "false"
        ? false
        : undefined;

export const SP_DEFAULT_WOKA_TEXTURE = searchParams.get("defaultWokaTexture") ?? undefined;
export const SP_PROVIDE_DEFAULT_WOKA_TEXTURE =
    searchParams.get("provideDefaultWokaTexture") === "no"
        ? "no"
        : searchParams.get("provideDefaultWokaTexture") === "random"
        ? "random"
        : searchParams.get("provideDefaultWokaTexture") === "fix"
        ? "fix"
        : undefined;
